module.exports = __webpack_public_path__ + "img/analisi.e1d05735.png";